import { useAppSelector } from '../../../hooks/redux'
import { Strings } from '../../../constants/Strings'
import { Colors } from '../../../constants/Colors'
import style from '../../../rootStyles/Content.module.css'
import Header from '../../../components/Header/Header'
import { Methods } from '../../../constants/Methods'

const Content = () => {

    const theme = useAppSelector<string>(state => state.theme.theme)
    const language = useAppSelector<string>(state => state.language.language)
    
    return (
        <div
            className={style.container}
            style={{
                backgroundColor: Colors[theme ?? 'light'].background
            }}
        >
            <Header
                leftIcon={null}
                leftPath={null}
                leftClick={null}
                title={Strings[language ?? 'tm'].termsOfUse}
                rightIcon={null}
                rightPath={null}
                rightClick={null}
            />
            <div
                className={style.content}
            >
                <div className={style.textsContainer}>

                    <span
                        className={style.title}
                        style={{
                            color: Colors[theme ?? 'light'].app
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseTitle}
                    </span>

                    {/* PROFILES */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers}
                    </span>
                    
                    {/* 1. PROFILES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers1}
                    </span>
                    
                    {/* 2. PROFILES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers2}
                    </span>
                    
                    {/* 3. PROFILES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers3}
                    </span>
                    
                    {/* 4. PROFILES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers4}
                    </span>
                    
                    {/* 5. PROFILES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers5}
                    </span>
                    
                    {/* 6. PROFILES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers6}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsersComment1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsersComment2}
                    </span>
                    
                    {/* 7. PROFILES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers7}
                    </span>
                        
                    {/* 8. PROFILES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers8}
                    </span>
                        
                    {/* 9. PROFILES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers9}
                    </span>
                        
                    {/* 10. PROFILES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseUsers10}
                    </span>
                    


                    {/* STORES */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores}
                    </span>

                    {/* 1. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores1}
                    </span>

                    {/* 2. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores2}
                    </span>

                    {/* 3. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores3}
                    </span>
                    
                    {/* 4. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores4}
                    </span>
                    
                    {/* 5. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores5}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStoresAnnouncement1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStoresAnnouncement2}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStoresAnnouncement3}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStoresAnnouncement4}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStoresAnnouncement5}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStoresAnnouncement6}
                    </span>

                    {/* 6. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores6}
                    </span>

                    {/* 7. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores7}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStoresComment1}
                    </span>
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStoresComment2}
                    </span>
                        
                    {/* 8. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores8}
                    </span>
                        
                    {/* 9. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores9}
                    </span>
                        
                    {/* 10. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores10}
                    </span>
                        
                    {/* 11. STORES */}
                    <span
                        className={style.aboutText}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].termsOfUseStores11}
                    </span>
                    


                    {/* SUPPORTS AND CONTACTS */}
                    <span
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {Strings[language ?? 'tm'].appSupport}
                    </span>
                    <a
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                        href="mailto:lezzetsebeti@gmail.com"
                    >
                        {Strings[language ?? 'tm'].email}: lezzetsebeti@gmail.com
                    </a>
                    <a
                        className={style.aboutTitle}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                        href="tel:+99371814745"
                    >
                        {Strings[language ?? 'tm'].phone}: {Methods.getNextPhone('+993 71814745')}
                    </a>

                    {/* COPYRIGHT */}
                    <span
                        className={style.title}
                        style={{
                            color: Colors[theme ?? 'light'].app
                        }}
                    >
                        {Strings[language ?? 'tm'].copyright}
                    </span>
                        
                </div>
            </div>
        </div>
    )
}

export default Content